export default "__VITE_ASSET__D$s62Jjp__"